import { useState } from "react";
import { Dialog } from "../../../../../../../../../../editComponents/Dialog/Dialog";
import { IPrintableCard } from "../../interfaces/IPrintableCard";
import styles from "./PrintableEventLogo.module.scss";
import { EventLogo, TEventLogo } from "../../../../../../../../../../components/EventLogo/EventLogo";
import { EventLogoSettings } from "../../../../../../../../../../components/EventLogo/components/EventLogoSettings/EventLogoSettings";
import { Updater } from "use-immer";

interface IProps {
    card: IPrintableCard;
    editMode: boolean;
    eventLogo: TEventLogo;
    updateCard?: Updater<IPrintableCard>;
    className: string;
}

export function PrintableEventLogo(props: IProps) {
    const [showModal, setShowModal] = useState(false);

    const updateEventLogo = (eventLogo: TEventLogo) => {
        if (props.updateCard) {
            props.updateCard((draft) => {
                draft.eventLogo = eventLogo;
            });
        }
    };

    return (
        <>
            <Dialog open={showModal} handleClose={() => setShowModal(false)} closableByOutsideClickAndEsc={true}>
                <>
                    <EventLogoSettings
                        updateEventLogo={updateEventLogo}
                        eventLogo={props.eventLogo}
                        close={() => setShowModal(false)}
                    />
                </>
            </Dialog>
            <div
                onClick={props.editMode ? () => setShowModal(true) : undefined}
                className={`${props.className} ${props.editMode ? styles.editMode : ""}`}
                
            >
                <EventLogo type="PRINT" cardLayout={props.card.layout} eventLogo={props.eventLogo} />
            </div>
        </>
    );
}
